/**
 * External dependencies
 */
export default class PayType {
    constructor(cscom) {
        if (!(this instanceof PayType)) {
            return new PayType(cscom);
        }
        this.cscom = cscom;
    }

    getPaytypes() {
        return this.cscom.req.get('/user-site-api/user-paytype-details');
    }
}
